// While a query serves the PREVIOUS key's data (`placeholderData: keepPreviousData`), the rows on
// screen belong to the filter the user just left — correct data, wrong filter, for a few hundred ms.
// Dimming them says "being replaced" without the blank-then-repaint a skeleton causes, and callers
// pair it with `aria-busy` so a screen reader is told the same thing rather than reading stale rows
// as settled.
//
// Deliberately NOT a spinner: the point of keeping previous data is that the user always has
// something to look at, and a spinner on top of it would reintroduce exactly the interruption the
// placeholder exists to remove. The app-wide `FetchingBar` already signals the in-flight request.
export function placeholderDim(isPlaceholderData: boolean): string {
  return 'transition-opacity duration-150' + (isPlaceholderData ? ' opacity-50' : '');
}
